import React from 'react';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { ModalReact, ModalType } from 'common/components/modal';
import { ButtonTheme } from 'common/components/button/constants';
import { useTranslation } from 'common/i18n/hooks';
import { Visibility } from 'common/components/base/stackable';
import { ButtonReact } from 'common/components/button';
import { InputReact } from 'common/components/input';
import { InputSize } from 'common/components/input/types';
import { InputLabelReact } from 'common/components/input/label';
import { useDecideExperiment } from 'iron/apps/experiments/src/components/hooks/decide-experiment';
import styles from './_decide-modal.module.styl';
type ExperimentPageBannerDecideModalProps = {
  onClose: () => void;
};
export function ExperimentPageBannerDecideModal(props: ExperimentPageBannerDecideModalProps) {
  var _experimentState$resu, _experimentState$resu2;
  const {
    t
  } = useTranslation();
  const experimentState = useExperimentsStore(state => state.experimentState!);
  const decideExperiment = useDecideExperiment();
  const [message, setMessage] = React.useState((_experimentState$resu = (_experimentState$resu2 = experimentState.results_cache) === null || _experimentState$resu2 === void 0 ? void 0 : _experimentState$resu2.message) !== null && _experimentState$resu !== void 0 ? _experimentState$resu : "");
  const handleDecision = React.useCallback((success: boolean) => {
    decideExperiment(success, message);
  }, [message, decideExperiment]);
  return <ModalReact closeable modalType={ModalType.Modal} modalTitle={t("experiments.banner.decide.title")} modalDescription={t("experiments.banner.decide.description")} open onChange={(event: TODO) => {
    if (event.detail.state === Visibility.Closed) {
      props.onClose();
    }
  }} data-sentry-element="ModalReact" data-sentry-component="ExperimentPageBannerDecideModal" data-sentry-source-file="_decide-modal.tsx">
      <div className={styles.modalBody}>
        <div className={styles.title}>{t("experiments.banner.decide.title")}</div>
        <div>{t("experiments.banner.decide.description")}</div>
        <div className={styles.form}>
          <div>
            <InputLabelReact fieldId='decide-message' label={t("experiments.banner.decide.message-label")} data-sentry-element="InputLabelReact" data-sentry-source-file="_decide-modal.tsx" />
            <InputReact className={styles.fullWidth} size={InputSize.Large} type='textarea' value={message} onInput={ev => {
            setMessage(ev.target.value);
          }} data-sentry-element="InputReact" data-sentry-source-file="_decide-modal.tsx" />
          </div>
          <div className={styles.formActions}>
            <ButtonReact theme={ButtonTheme.Secondary} onClick={() => {
            handleDecision(false);
            props.onClose();
          }} data-sentry-element="ButtonReact" data-sentry-source-file="_decide-modal.tsx">
              {t("experiments.banner.decide.not-ship")}
            </ButtonReact>
            <ButtonReact theme={ButtonTheme.Primary} onClick={() => {
            handleDecision(true);
            props.onClose();
          }} data-sentry-element="ButtonReact" data-sentry-source-file="_decide-modal.tsx">
              {t("experiments.banner.decide.ship")}
            </ButtonReact>
          </div>
        </div>
      </div>
    </ModalReact>;
}